import { Navigate } from 'react-router-dom'
import SubscriptionGate from '../../components/Subscriptions/SubscriptionGate'
import CoursePlayer from '../pages/CoursePlayer'
import Assessment from '../pages/Assessment'
import CourseFeedback from '../pages/CourseFeedback'
import CourseCertificate from '../pages/CourseCertificate'
import QuestionBank from '../pages/QuestionBank'
import VerifyCertificate from '../pages/VerifyCertificate'
import BlockGallery from '../pages/BlockGallery'
import FocusLayout from '../components/FocusLayout'

// E-learning course engine. The courses themselves need Premium; training
// records (certificate upload, the course list, the matrix) are on every
// tier and live in EmployeeRoutes.
export default [
  {
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="E-learning"
        caption="Mandatory training courses your staff complete inside AmbuNet."
        benefits={[
          'Statutory and mandatory courses mapped to the Core Skills Training Framework.',
          'Completions go straight onto each staff record and your training matrix.',
          'Certificates with a verification code, and reminders before training expires.',
        ]}
      />
    ),
    children: [
      {
        // Courses run in their own frame, without the app's navigation.
        element: <FocusLayout />,
        children: [
          { path: '/training/course/:enrolmentId', element: <CoursePlayer />, title: 'Training' },
          { path: '/training/course/:enrolmentId/assessment', element: <Assessment />, title: 'Assessment' },
          { path: '/training/course/:enrolmentId/feedback', element: <CourseFeedback />, title: 'Course feedback' },
          { path: '/training/course/:enrolmentId/certificate', element: <CourseCertificate />, title: 'Certificate' },
          { path: '/training/course/:enrolmentId/bank', element: <QuestionBank />, title: 'Question bank' },
        ],
      },
      // Every block type on one page, for the automated accessibility checks.
      { path: '/training/dev/blocks', element: <BlockGallery />, title: 'Training blocks' },
    ],
  },
  // Also in PublicRouter: a certificate's QR code must open for anyone,
  // signed in or not.
  { path: '/training/verify/:verificationId', element: <VerifyCertificate />, title: 'Verify a certificate' },
  // The hard-coded courses that used to live under /e-learning were retired
  // in 2026-10; old links and bookmarks land on My Training.
  { path: '/e-learning/*', element: <Navigate to="/mandatory-training" replace /> },
]
